import * as types from './mutation_types';

export default {
  [types.UID](state, uid) {
    state.uid = uid;
  },
  [types.ERROR_STATE](state, errorState) {
    state.errorState = errorState;
  },
  [types.IS_AUTH](state, isAuth) {
    state.isAuth = isAuth;
  },
  [types.MENUS](state, menus) {
    state.menus = menus;
  },
  [types.LOCALE](state, locale) {
    state.locale = locale;
  },
  [types.PARAMS](state, params) {
    state.params = params;
  },
  [types.GMT](state, gmt) {
    state.gmt = gmt;
  },
  [types.USER_ETC_INFOS](state, userEtcInfos) {
    state.userEtcInfos = userEtcInfos;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js